
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import preguntas from './barra-preguntas-listado.vue';
    import declaracion from './barra-lateral-subir-declaracion.vue';
    import validarpago from './barra-lateral-validar-pago.vue';
    import agregarpago from './barra-lateral-agregar-pago.vue';
    import archivos from './barra-lateral-archivos.vue';
    import procesos from './barra-lateral-procesos.vue';
    import entregar from './barra-lateral-entregar.vue';
    import { ControladorInterfaz} from '../../../controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            preguntas,
            archivos,
            declaracion,
            procesos,
            validarpago,
            agregarpago,
            entregar,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }
        public Abierto: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {


            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onAbierto.subscribe( () =>
            {
                this.Abierto = this.Controlador.Vista.BarraDerecha.Abierto;

                if ( !this.Abierto )
                    this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 0;

            } ) );


            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onModo.subscribe( () =>
            {
                if ( this.Modo )
                {
                    this.Controlador.Vista.Menu.Abierto = false;
                    this.Controlador.Vista.BarraDerecha.Abierto = true;
                } else
                {
                    this.Controlador.Vista.BarraDerecha.Abierto = false;
                }



            } ) );
        }

    }
